import {toast} from 'react-toastify';
import {put, takeEvery, select} from 'redux-saga/effects';
import {
  getAllSudoUserFeatureFlagsApi,
  getSudoUserApi,
  getSudoUsersApi,
  updateSudoUserApi
} from 'helpers/services/api/adminSudoUsers';
import {
  CLEAR_SUDO_USER,
  CREATE_SUDO_USER,
  GET_ALL_SUDO_USER_FEATURE_FLAGS,
  GET_ALL_SUDO_USER_FEATURE_FLAGS_SUCCESS,
  GET_SUDO_USER,
  GET_SUDO_USER_SUCCESS,
  GET_SUDO_USERS,
  GET_SUDO_USERS_SUCCESS,
  UPDATE_SUDO_USER
} from 'store/adminSudoUsers/action';
import {addTeamMemberApi} from '../../helpers/services/api/account';

const getAdminSudoUsersState = ({adminSudoUsersReducer}) =>
  adminSudoUsersReducer;

function* getSudoUsers({payload}) {
  try {
    const {data} = yield getSudoUsersApi(payload);
    if (data) {
      yield put(GET_SUDO_USERS_SUCCESS(data));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* getSudoUser({payload}) {
  try {
    const {data} = yield getSudoUserApi(payload);
    if (data) {
      yield put(GET_SUDO_USER_SUCCESS(data));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* updateSudoUser({payload}) {
  try {
    const {
      paging: {page},
      search,
      sort
    } = yield select(getAdminSudoUsersState);
    const {data} = yield updateSudoUserApi(payload.id, payload.data);
    if (data) {
      toast.success('User updated successfully');
      yield put(CLEAR_SUDO_USER());
      yield put(GET_SUDO_USERS({page, search, sort}));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* createSudoUser({payload}) {
  try {
    const {
      paging: {page},
      search,
      sort
    } = yield select(getAdminSudoUsersState);
    const {data} = yield addTeamMemberApi(
      process.env.REACT_APP_ENV === 'production'
        ? '133e5b1d-d118-4c0c-ba2c-1d8fe2b37dcc'
        : 'b57148a9-58a1-4019-a596-37e2a940a691',
      process.env.REACT_APP_ENV === 'production'
        ? 'cb00d084-0338-471c-94ea-3690de575f7b'
        : 'bba5d2d3-9ecb-4e0f-a034-dd638395e68b',
      payload
    );
    if (data) {
      toast.success('User created successfully');
      yield put(CLEAR_SUDO_USER());
      yield put(GET_SUDO_USERS({page, search, sort}));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* getAllSudoUserFeatureFlags() {
  try {
    const {data} = yield getAllSudoUserFeatureFlagsApi();
    if (data) {
      yield put(GET_ALL_SUDO_USER_FEATURE_FLAGS_SUCCESS(data));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* adminSudoUsersSaga() {
  yield takeEvery(GET_SUDO_USERS, getSudoUsers);
  yield takeEvery(GET_SUDO_USER, getSudoUser);
  yield takeEvery(UPDATE_SUDO_USER, updateSudoUser);
  yield takeEvery(GET_ALL_SUDO_USER_FEATURE_FLAGS, getAllSudoUserFeatureFlags);
  yield takeEvery(CREATE_SUDO_USER, createSudoUser);
}

export default adminSudoUsersSaga;
